// import Vue from "vue";
//import Router from "vue-router";
import { createRouter, createWebHistory } from "vue-router"
import store from "./store/index"
import i18n from "./i18n"

import NotFound404 from "./components/exceptions/404.vue"
import WelcomePage from "./components/welcome/welcome.vue"
import DashboardPage from "./components/dashboard/dashboard.vue"
import DevicesPage from "./components/devices/devices.vue"
import LoraPage from "./components/devices/lora.vue"
import MqttPage from "./components/devices/mqtt.vue"
import HttpPage from "./components/devices/http.vue"
import UdpPage from "./components/devices/udp/udp.vue"
import SimcardsPage from "./components/simcards/simcards.vue"
import MqttDevicePage from "./components/devices/mqttDevice.vue"
import GatewaysPage from "./components/endpoints/gateways.vue"
import ImportPage from "./components/devices/import.vue"
import BulkImportPage from "./components/devices/bulkImport.vue"
import ArticlePage from "./components/article/article.vue"
import ArticlesPage from "./components/article/articles.vue"
import DevicePage from "./components/devices/device.vue"
import ServicePage from "./components/services/service.vue"
import CallbackPage from "./components/callback/callback.vue"
import EndpointsPage from "./components/endpoints/endpoints.vue"
import EndpointPage from "./components/endpoints/endpoint.vue"
import GatewayPage from "./components/endpoints/gateway.vue"
import SignalCheckerPage from "./components/signal-checker/signal-checker.vue"
import NewDataFlow from "./components/groups/new.vue"
import GroupsPage from "./components/groups/groupsPage.vue"
import GroupPage from "./components/groups/group.vue"
import ProfilePage from "./components/profile.vue"
import FaqPage from "./components/faq/faq.vue"
import AdminPage from "./components/admin/adminPage.vue"
import AdminMenuPage from "./components/admin/menuPage.vue"
import AdminCustomerPage from "./components/admin/customerPage.vue"
import AdminProjectPage from "./components/admin/projectPage.vue"
import AdminMenuProjectNewPage from "./components/admin/project/new.vue"
import AdminMenuProjectInfoPage from "./components/admin/project/info.vue"
import AdminMenuProjectServicesLimitsPage from "./components/admin/project/services.vue"
import AdminMenuProjectUsersPage from "./components/admin/project/users.vue"
import AdminMenuProjectLogsPage from "./components/admin/project/logs.vue"
import AdminMenuCustomerServicesLimitsPage from "./components/admin/customer/services.vue"
import AdminMenuCustomerUsersPage from "./components/admin/customer/users.vue"
import AdminMenuCustomerUsersNotificationsPage from "./components/admin/customer/usersNotifications.vue"
import AdminMenuCustomerLogsPage from "./components/admin/customer/logs.vue"
import AdminMenuCustomerProjectsPage from "./components/admin/customer/projects.vue"
import AdminResellerPage from "./components/admin/resellerPage.vue"
import AdminMenuResellerInfoPage from "./components/admin/admin/info.vue"
import AdminMenuResellerLogsPage from "./components/admin/admin/logs.vue"
import SimcardPage from "./components/simcards/simcard"
import NewSimcardPage from "./components/simcards/new-request"
import TransformationFunctionsPage from "./components/transformation-functions/TransformationFunctions.vue"
import UdpDevicePage from "./components/devices/udp/udpDevice.vue"
import AboutPage from "./components/about.vue"
import HwCatalogue from "@/components/hw-catalogue/hwCatalogue.vue"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"
import { useCustomerStore } from "@/store/modules/customer"

var router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
  routes: [
    {
      /**
       * redirect to dashboard is done in /gui/src/store/modules/auth.js
       * because we need to get selectedCustomer and selectedProject first
       */
      path: "/",
      name: "home",
      component: WelcomePage,
      meta: {
        title: "IoT Portal pro správu IoT zařízení zákazníků CRA",
        requiresAuth: true
      }
    },
    {
      path: "/about",
      name: "about",
      component: AboutPage,
      meta: {
        title: "About",
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        next()
      }
    },
    {
      path: "/faq",
      name: "faq",
      component: FaqPage,
      meta: {
        title: "titleFAQ",
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        next()
      }
    },
    {
      path: "/article/:id",
      name: "article-detail",
      component: ArticlePage,
      meta: {
        title: "titleNovinka",
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        next()
      }
    },
    {
      path: "/articles",
      name: "articles",
      component: ArticlesPage,
      meta: {
        title: "titleNovinky",
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        next()
      }
    },
    {
      path: "/callback",
      name: "callback",
      component: CallbackPage,
      meta: {
        title: "titleCallback"
      },
      beforeEnter(to, from, next) {
        next()
      }
    },
    {
      path: "/devices/:customerId/:projectId",
      name: "devices",
      component: DevicesPage,
      redirect: (to) => ({ path: `/devices/lora/${to.params.customerId}/${to.params.projectId}` }),
      meta: {
        title: "titleZarizeni",
        requiresAuth: true
      },
      children: [
        {
          path: "/devices/lora/:customerId/:projectId",
          name: "lora",
          component: LoraPage,
          meta: {
            title: "LORA_ZARIZENI"
          }
        },
        {
          path: "/devices/mqtt/:customerId/:projectId",
          name: "mqttDevices",
          component: MqttPage,
          meta: {
            title: "MQTT_ZARIZENI",
            requiresAuth: true
          }
        },
        {
          path: "/devices/http/:customerId/:projectId",
          name: "httpDevices",
          component: HttpPage,
          meta: {
            title: "HTTP_ZARIZENI",
            requiresAuth: true
          }
        },
        {
          path: "/devices/udp/:customerId/:projectId",
          name: "udpDevices",
          component: UdpPage,
          meta: {
            title: "UDP_ZARIZENI",
            requiresAuth: true
          }
        },
        {
          path: "/devices/lora/:customerId/:projectId/import",
          name: "import",
          component: ImportPage,
          meta: {
            title: "titleImportZarizeni",
            layout: "no-sidebar"
          },
          props: true
        },
        {
          path: "/devices/lora/:customerId/:projectId/bulk-import",
          name: "bulkImport",
          component: BulkImportPage,
          meta: {
            title: "titleHromadnyImportZarizeni",
            layout: "no-sidebar"
          },
          props: true
        }
      ]
    },
    {
      path: "/gate/mqtt/:customerId/:projectId",
      name: "mqttEndpoints",
      component: GatewaysPage,
      meta: {
        title: "titleMqttZarizeni",
        requiresAuth: true
      }
    },
    {
      path: "/endpoints/:customerId/:projectId",
      name: "endpoints",
      component: EndpointsPage,
      meta: {
        title: "titleEndpointy",
        requiresAuth: true
      }
    },
    {
      path: "/gate/mqtt/:customerId/:projectId/:id",
      name: "mqttEndpoint",
      component: GatewayPage,
      meta: {
        title: "titleEndpoint",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/endpoint/:customerId/:projectId/:id",
      name: "endpoint",
      component: EndpointPage,
      meta: {
        title: "titleEndpoint",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/groups/:customerId/:projectId",
      name: "groups",
      component: GroupsPage,
      meta: {
        title: "titleRoutovaciSkupiny",
        requiresAuth: true
      }
    },
    {
      path: "/groups/:customerId/:projectId/new",
      name: "dataFlowNew",
      component: NewDataFlow,
      meta: {
        requiresAuth: true,
        layout: "no-sidebar",
        title: "TITLE_NEW_DATA_FLOW"
      }
    },
    {
      path: "/group/:customerId/:projectId/:id/:tab?",
      name: "group",
      component: GroupPage,
      meta: {
        title: "titleSkupina",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/device/:customerId/:projectId/:id",
      name: "device",
      component: DevicePage,
      meta: {
        title: "titleZarizeni",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/simcards/:customerId/:projectId",
      name: "simcards",
      component: SimcardsPage,
      meta: {
        title: "titleSimcards",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/simcards/:customerId/:projectId/new",
      name: "newSimcard",
      component: NewSimcardPage,
      meta: {
        title: "titleNewSimcard",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/simcards/:customerId/:projectId/:serviceId/:id",
      name: "simcard",
      component: SimcardPage,
      meta: {
        title: "titleSimcards",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/device/mqtt/:customerId/:projectId/:id",
      name: "mqttDevice",
      component: MqttDevicePage,
      meta: {
        title: "titleZarizeni",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/device/udp/:customerId/:projectId/:id",
      name: "udpDevice",
      component: UdpDevicePage,
      meta: {
        title: "titleZarizeni",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/service/:customerId/:projectId/:id",
      name: "service",
      component: ServicePage,
      meta: {
        title: "titleSluzba",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/signal-checker",
      name: "signal-checker",
      component: SignalCheckerPage,
      meta: {
        title: "titleSignalChecker",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/dashboard",
      name: "dashboardRedir1",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dashboard/:customerId",
      name: "dashboardRedir",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/groups/:customerId",
      name: "groupsRedir",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/endpoints/:customerId",
      name: "endpointsRedir",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dashboard/:customerId/:projectId",
      name: "dashboard",
      meta: {
        title: "titleDashboard",
        requiresAuth: true
      },
      component: DashboardPage
    },
    {
      path: "/profile",
      name: "profile",
      meta: {
        title: "titleProfilUzivatele",
        requiresAuth: true
      },
      component: ProfilePage
    },
    {
      path: "/transformation-functions/:customerId/:projectId",
      name: "transformationFunctions",
      component: TransformationFunctionsPage,
      meta: {
        title: "titleTransformationFunctions",
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/hw-catalogue",
      name: "hwCatalogue",
      component: HwCatalogue,
      meta: {
        title: "hwCatalogue",
        requiresAuth: true
      },
      props: true
    },
    {
      /**
       * projectId is optional across the admin menu: a customer with no project at all has
       * to be able to get here to create its first one. Only the genuinely project-scoped
       * pages below (adminProject*) keep it required.
       */
      path: "/admin/:customerId/:projectId?",
      name: "admin",
      meta: {
        title: "titleMenuSpravce",
        requiresAuth: true,
        layout: "no-sidebar"
      },
      redirect: (to) => ({
        name: "adminMenu",
        params: to.params.projectId
          ? { customerId: to.params.customerId, projectId: to.params.projectId }
          : { customerId: to.params.customerId }
      }),
      component: AdminPage,
      children: [
        {
          path: "/admin/menu/:customerId/:projectId?",
          name: "adminMenu",
          component: AdminMenuPage,
          meta: {
            title: "titleMenuSpravce",
            requiresAuth: true,
            layout: "no-sidebar"
          },
          props: true
        },
        {
          path: "/admin/reseller/:customerId/:projectId?",
          name: "reseller",
          component: AdminResellerPage,
          meta: {
            title: "titleReseller",
            requiresAuth: true,
            layout: "no-sidebar"
          },
          props: true,
          children: [
            {
              path: "/admin/reseller/info/:customerId/:projectId?",
              name: "adminResellerInfo",
              component: AdminMenuResellerInfoPage,
              meta: {
                title: "titleInformaceOSpravci",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            },
            {
              path: "/admin/reseller/logs/:customerId/:projectId?",
              name: "adminResellerLogs",
              component: AdminMenuResellerLogsPage,
              meta: {
                title: "titleLogOperaci",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            }
          ]
        },
        {
          path: "/admin/customer/:customerId",
          name: "customer",
          component: AdminCustomerPage,
          meta: {
            title: "titleZakaznik",
            requiresAuth: true,
            layout: "no-sidebar"
          },
          props: true,
          children: [
            {
              path: "/admin/customer/services-limits/:customerId",
              name: "adminCustomerServicesLimits",
              component: AdminMenuCustomerServicesLimitsPage,
              meta: {
                title: "titleSluzbyALimity",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            },
            {
              path: "/admin/customer/users/:customerId",
              name: "adminCustomerUsers",
              component: AdminMenuCustomerUsersPage,
              meta: {
                title: "titleVypisUzivatelu",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            },
            {
              path: "/admin/customer/users/notifications/:customerId",
              name: "adminCustomerUsersNotifications",
              component: AdminMenuCustomerUsersNotificationsPage,
              meta: {
                title: "titleVypisUzivatelu",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            },
            {
              path: "/admin/customer/logs/:customerId",
              name: "adminCustomerLogs",
              component: AdminMenuCustomerLogsPage,
              meta: {
                title: "titleLogOperaci",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            },
            {
              path: "/admin/customer/projects/:customerId",
              name: "adminCustomerProjects",
              component: AdminMenuCustomerProjectsPage,
              meta: {
                title: "titlePrehledProjektu",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            }
          ]
        },
        {
          path: "/admin/project/:customerId",
          name: "project",
          component: AdminProjectPage,
          meta: {
            title: "titleProjekt",
            requiresAuth: true,
            layout: "no-sidebar"
          },
          props: true,
          children: [
            {
              path: "/admin/project/new",
              name: "adminProjectNew",
              component: AdminMenuProjectNewPage,
              meta: {
                title: "titleNovyProjekt",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            },
            {
              path: "/admin/project/info/:customerId/:projectId",
              name: "adminProjectInfo",
              component: AdminMenuProjectInfoPage,
              meta: {
                title: "titleInformaceOProjektu",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            },
            {
              path: "/admin/project/services-limits/:customerId/:projectId",
              name: "adminProjectServicesLimits",
              component: AdminMenuProjectServicesLimitsPage,
              meta: {
                title: "titleSluzbyALimity",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            },
            {
              path: "/admin/project/users/:customerId/:projectId",
              name: "adminProjectUsers",
              component: AdminMenuProjectUsersPage,
              meta: {
                title: "titleVypisUzivatelu",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            },
            {
              path: "/admin/project/logs/:customerId/:projectId",
              name: "adminProjectLogs",
              component: AdminMenuProjectLogsPage,
              meta: {
                title: "titleLogOperaci",
                requiresAuth: true,
                layout: "no-sidebar"
              },
              props: true
            }
          ]
        }
      ]
    },
    {
      path: "/:pathMatch(.*)*",
      component: NotFound404,
      name: "NotFound404",
      meta: {
        title: "titleNotFound404",
        requiresAuth: true
      },
      beforeEnter(to, from, next) {
        next()
      }
    }
  ],
  //linkActiveClass: "active",
  linkExactActiveClass: "active"
})

export default router

router.beforeEach(async (to, from, next) => {
  const configStore = useConfigStore()
  const customerStore = useCustomerStore()
  const authStore = useAuthStore()

  await configStore.setLang()

  try {
    await configStore.checkURLs()

    if (!configStore.connectionSSOOk) {
      // SSO unreachable — allow navigation so the URLerrors banner renders.
      return next()
    }

    if (authStore.user) {
      if (!customerStore.customerList) {
        await customerStore.getCustomerList()
      }
      return next()
    }

    if (to.matched.some((record) => record.meta.requiresAuth)) {
      try {
        await authStore.authenticate(to.path)
      } catch (e) {
        // signinRedirect rejected; surface error UI and abort navigation
        // so vue-router does not hang in a pending state.
        console.error("[router] authenticate failed:", e)
        return next(false)
      }
      if (!authStore.user) {
        // signinRedirect was triggered; browser will navigate away.
        // Cancel the pending navigation so vue-router does not hang
        // if the redirect is delayed or fails silently.
        return next(false)
      }
      if (!customerStore.customerList) {
        await customerStore.getCustomerList()
      }
      return next()
    }

    return next()
  } catch (e) {
    console.error("[router] navigation guard failed:", e)
    return next()
  }
})
